import { put, select } from "redux-saga/effects";
import { addDebugMessage } from "../store/Utilities/actions";
import { getIsDebugWindowEnabledForSaga } from "../store/ClinicInformation/selectors";

export function* debugDispatchSaga(message: string, isError: boolean, payload?: any) {
    if (yield select(getIsDebugWindowEnabledForSaga))
        yield put(addDebugMessage(message, isError, payload));
}


// WEBPACK FOOTER //
// ./src/sagas/debugDispatchSaga.ts